import FacebookIcon from "@mui/icons-material/Facebook";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import YouTubeIcon from "@mui/icons-material/YouTube";
import { useTranslation } from "react-i18next";
import {
  Container,
  ContainerFooter,
  Content,
  DataContent,
  SocialMediaContent,
  TypographyDescriptionStyle,
  TypographyTitleStyle,
} from "./Footer.styles";

export default function Footer() {
  const { t } = useTranslation("login-page");

  function RightsReserved() {
    return (
      <ContainerFooter>
        <TypographyTitleStyle>U-Verify by Stratesys</TypographyTitleStyle>
        <TypographyDescriptionStyle>
          © Stratesys {new Date().getFullYear()} – {t("allRightsReserved")}
        </TypographyDescriptionStyle>
      </ContainerFooter>
    );
  }

  function StratesysLinks() {
    return (
      <ContainerFooter>
        <TypographyTitleStyle>Links</TypographyTitleStyle>
        <a
          href="https://www.stratesys-ts.com/pt/#aboutus"
          style={{ color: "inherit" }}
          target="_blank"
        >
          Stratesys
        </a>
        <a
          href="https://www.stratesys-ts.com/pt/#aboutus"
          style={{ color: "inherit" }}
          target="_blank"
        >
          {t("policyPrivacy")}
        </a>
      </ContainerFooter>
    );
  }

  function SocialMedias() {
    return (
      <ContainerFooter>
        <TypographyTitleStyle>{t("followUp")}</TypographyTitleStyle>
        <SocialMediaContent>
          <a href="https://www.facebook.com/stratesysbrasil" target="_blank">
            <FacebookIcon fontSize="large" color="action" />
          </a>
          <a
            href="https://www.linkedin.com/company/stratesys-brasil/"
            target="_blank"
          >
            <LinkedInIcon color="action" fontSize="large" />
          </a>
          <a href="https://www.youtube.com/user/stratesys" target="_blank">
            <YouTubeIcon color="action" fontSize="large" />
          </a>
        </SocialMediaContent>
      </ContainerFooter>
    );
  }

  return (
    <Container>
      <Content />
      <DataContent>
        {SocialMedias()}
        {RightsReserved()}
        {StratesysLinks()}
      </DataContent>
    </Container>
  );
}
